import CloseIcon from '@mui/icons-material/Close';
import {
    AppBar,
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid2,
    IconButton,
   
    Slide,
    Toolbar,
    Typography,
    useTheme
} from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import React, { FC, forwardRef, useEffect, useMemo, useState } from 'react';
import { SearchInput } from '../../../Form/InputSearch/input-search.component';
import { ListCustomersUseCase } from '../../../../Usecase/Customers/list-customers-usecase';
import { useToast } from '../../../../Hooks/ToasContext';
import { ICreateCustomerPayload, ICustomerEntity, IUpdateCustomerPayload } from '../../../../Services/api/customers/customers.interface';
import { Table } from '../../../Table/table.component';
import { SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { Input } from '../../../Form/Input/input.component';
import InputMaskComponent from '../../../Form/InputMask/input-mask.component';
import { Button } from '../../../Form/Button/button.scomponent';
import { IAddressEntity, ICreateAddressPayload } from '../../../../Services/api/addresses/addresses.interface';
import { SearchAddressesUseCase } from '../../../../Usecase/Addresses/search-addresses-usecase';
import { removeNonNumeric } from '../../../../utils/removeNonNumeric';
import { Loader } from '../../../Loader';
import { CreateAddressesUseCase } from '../../../../Usecase/Addresses/create-addresses-usecase';
import { ShowAddressesUseCase } from '../../../../Usecase/Addresses/show-addresses-usecase';

interface IAddressVariantProps {
    addressSelected?: IAddressEntity
    onClose: () => void
    handleNewLocalAddress: (address: IAddressEntity) => void
    handleUpdateAddress: (address: IAddressEntity) => void
    handleUpdateLocalAddress: (address: IAddressEntity) => void
    searchAddressesUseCase: SearchAddressesUseCase
    handleCreateNewAddress: (address: ICreateAddressPayload) => Promise<void>
    fromEdit?: boolean
    customerId?: string
    
 

}

interface CreateAddressSchemaValidation {
    name: string;
    number?: string;
    complement?: string;
    locality: string;
    zipcode: string;
    city: string;
    province: string
  }

    
  const CreateAddressSchemaValidation = Yup.object().shape({
      name: Yup.string().required('Rua é obrigatório'),
      number: Yup.string(),
      complement: Yup.string(),
      locality: Yup.string().required('Bairro é obrigatório'),
      zipcode: Yup.string().required('CEP é obrigatório'),
      city: Yup.string().required('Cidade é obrigatório'),
      province: Yup.string()
        .required('Estado é obrigatório')
        .max(2, 'Estado deve ter no máximo 2 caracteres')
        .transform(value => value?.toUpperCase()),
    });
  

const AddressModal : FC<IAddressVariantProps> = ({ addressSelected, onClose, handleNewLocalAddress, handleUpdateAddress, searchAddressesUseCase, fromEdit, handleCreateNewAddress, customerId, handleUpdateLocalAddress }) => {
    const [loading, setLoading] = useState(false)
    const [customers, setCustomers] = useState<ICustomerEntity[]>([])
    const { showToast } = useToast()

    const { handleSubmit, register, control, formState, watch, setValue } = useForm<IAddressEntity>({
            resolver: yupResolver(CreateAddressSchemaValidation),
          });
    
  
    const { errors } =  formState

    const Transition = forwardRef(function Transition(
        props: TransitionProps & {
        children: React.ReactElement<any, any>;
        },
        ref: React.Ref<unknown>,
    ) {
        return <Slide direction="up" ref={ref} {...props} />;
    });
  
 


  const handleAction: SubmitHandler<CreateAddressSchemaValidation> = async (values) => {
          
          try {
            
            if(fromEdit){
              if(addressSelected?.id){
                handleUpdateAddress({ ...values, number: values.number || '', id: addressSelected.id })
              }else{

                const payloadCreate: ICreateAddressPayload = {
                  ...values,
                  number: values.number || '',
                  customerId: customerId || ''
                }

                
                handleCreateNewAddress(payloadCreate)
                
              }

            } else {
              if(addressSelected?.id){
                handleUpdateLocalAddress({ ...values, number: values.number || '', id: addressSelected.id })
              }else{
                handleNewLocalAddress({ ...values, number: values.number || '' })
              }
            }

            
            
            onClose()
          
  
          } catch (error) {
              console.log("error: ", error)
              showToast(error.response?.data?.error ?? 'Erro. Por favor, tente novamente', 'error');
           
          } finally {
            setLoading(false);
          }
  };

  const handleSearchAddress = async (zipcode: string) => {
    if(zipcode.length < 8) return
    try {
      setLoading(true)
      
      const showResult = await searchAddressesUseCase.handle(zipcode);

      if (showResult.isFailure) {
        showToast(String(showResult?.error?.error), 'error');
        return;
      }

     const address = showResult.getValue()

     if(address?.zipcode){
      setValue('city', address.city)
      setValue('province', address.province)
      setValue('locality', address.locality)
      setValue('zipcode', address.zipcode)
      setValue('name', address.name)
      setValue('complement', address.complement)
     }

    

    } catch (error) {
      console.log("error listCustomers function: ", error)
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if(addressSelected){
      setValue('name', addressSelected.name)
      setValue('number', addressSelected.number)
      setValue('complement', addressSelected.complement)
      setValue('locality', addressSelected.locality)
      setValue('city', addressSelected.city)
      setValue('province', addressSelected.province)
      setValue('zipcode', addressSelected.zipcode)

    }
  }, [addressSelected])

  useEffect(() => {
    if(watch('zipcode')?.length > 7){
      handleSearchAddress(removeNonNumeric(watch('zipcode')))
    }
  }, [watch('zipcode')])

  

  

  return (
    <>
      <Dialog
        open
        // TransitionComponent={Transition}
        keepMounted
        onClose={onClose}
        aria-describedby="alert-dialog-slide-description"
        maxWidth="xl"
        fullWidth
      >
        {loading && <Loader />}
        <DialogTitle>Novo Endereço</DialogTitle>
        <Box component="form" onSubmit={handleSubmit(handleAction)}>
          <DialogContent>

          <Grid2 container spacing={5} >


            <Grid2 size={3}>
                <InputMaskComponent
                      label='CEP'
                      
                      helperText={errors?.zipcode?.message}
                      error={!!errors?.zipcode}
                      placeholder="Preencha o CEP"
                      mask='99999-999'
                      name="zipcode"
                      control={control}
                      
                  />
                  </Grid2>

            <Grid2 size={6}>

                <Input
                    label="Endereço"
                    placeholder="Preencha o Endereço"
                    error={!!errors.name}
                    helperText={errors.name?.message}
                    {...register('name')}
                    
                />
            </Grid2>

            <Grid2 size={3}>

                <Input
                    label="Número"
                    placeholder="Preencha o Número"
                    error={!!errors.number}
                    helperText={errors.number?.message}
                    {...register('number')}
                    
                />
            </Grid2>

            <Grid2 size={3}>

                <Input
                    label="Complemento"
                    placeholder="Preencha o Complemento"
                    error={!!errors.complement}
                    helperText={errors.complement?.message}
                    {...register('complement')}
                    
                />
            </Grid2>

            <Grid2 size={3}>

                <Input
                    label="Bairro"
                    placeholder="Preencha o Bairro"
                    error={!!errors.locality}
                    helperText={errors.locality?.message}
                    {...register('locality')}
                    
                />
            </Grid2>

            <Grid2 size={3}>

                <Input
                    label="Cidade"
                    placeholder="Preencha o Cidade"
                    error={!!errors.city}
                    helperText={errors.city?.message}
                    {...register('city')}
                    
                />
            </Grid2>

            <Grid2 size={3}>

                <Input
                    label="Estado"
                    placeholder="Preencha o Estado"
                    error={!!errors.province}
                    helperText={errors.province?.message || 'Apenas Sigla. Ex: SP'}
                    {...register('province', {
                      onChange: (e) => {
                        const value = e.target.value.toUpperCase();
                        if (value.length > 2) {
                          e.target.value = value.slice(0, 2);
                        }
                        setValue('province', value.slice(0, 2));
                      }
                    })}
                />
            </Grid2>

          </Grid2>

          </DialogContent>
          <DialogActions sx={{ marginBottom: '20px'}}>
          <Button type="submit" sx={{ marginTop: '10px', width: '200px' }} isLoading={loading}>
                      SALVAR
                  </Button>
            <Button onClick={onClose} sx={{ marginTop: '10px', width: '200px' }} variant='text'>Cancelar</Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  );
};

export default AddressModal;
